module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.9ece5b48.ttf";